import {selector, selectorFamily } from "recoil";
import axios from "axios";
import { baseurl } from "./baseurl";
import { userDataState,bearerToken } from "../atoms/dashboard";
import { otherDivData } from "../atoms/lattice";

export const carLatData = selector({
  key: "carLatData1",
  get: async ({ get, set }) => {
    const bearToken = get(bearerToken);
      axios.defaults.headers.common['Authorization'] = bearToken;
    try {
      
      const getLat = await axios.post(baseurl + "/lattice/getlattice", {
        divisionID: 71,
      });
      const latData = await getLat?.data;
      return latData;
    } catch (error) {
    
      console.log("error");
    }
  },
  set: () => {},
});
export const rolSkillLearn = selectorFamily({
  key: "rolSkillLearn",
  get: (ids) => async ({ get, set }) => {
    console.log(ids);
    const bearToken = get(bearerToken);
    axios.defaults.headers.common['Authorization'] = bearToken;
    try {
      const getjobdesc = await axios.post(
        baseurl + "/lattice/getjobdescription",
        {
          latticeID: ids.latticeID,
          designationID: ids.designationID,
        }
      );
      let getjobdescData = await getjobdesc?.data;

      console.log(getjobdescData);
      return getjobdescData;
    } catch (error) {
     
      console.log("error");
    }
  },
  set: () => {},
});

export const getMydivision1 = selector({
  key: "getMydivision",
  get: async ({ get, set }) => {
   
    const pgsid = get(userDataState);
    console.log(pgsid);
    const bearToken = get(bearerToken);
    axios.defaults.headers.common['Authorization'] = bearToken;
    try {
      const getMydiv = await axios.post(
        baseurl + "/api/lattice/getmydivision",
        {
          empID:pgsid.empID
        }
      );
      console.log(baseurl + "/lattice/getmydivision");
      let getMydivData = await getMydiv?.data;

      console.log('getmydata',getMydivData);
      return getMydivData;
    } catch (error) {
     
      console.log("error");
    }
  },
  set: () => {},
});
export const getOtherdivision = selector({
  key: "getOtherdivision",
  get: async ({ get, set }) => {
    const ids = get(otherDivData);
    console.log(ids);
    const bearToken = get(bearerToken);
    axios.defaults.headers.common['Authorization'] = bearToken;
    try {
      const getjobdesc = await axios.post(
        baseurl + "/api/lattice/getotherdivision",
        {
          locationID: ids.loc,
          divisionID: ids.div,
          teamID: ids.team,
          streamID: ids.stream,
          subStreamID: ids.substream
        }
      );
      let getjobdescData = await getjobdesc?.data;

      console.log(getjobdescData);
      return getjobdescData;
    } catch (error) {
     
      console.log("error");
    }
  },
  set: () => {},
});

